import React, { useState, useEffect } from "react";
import { Gmaps, Marker, InfoWindow, Circle } from "react-gmaps";
import { getLocationInfo } from "../../../providers/Location.provider";
import LoadingSpinner from "../../../partials/loading";

const KEY = "AIzaSyBOOJoVid8q6DuDK3VyRamHRj3UiiP3Zk8";
const params = { v: "3.exp", key: KEY };

const IPComponent = ({ _ip }) => {
    const [ip, setIp] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getLocationInfo(_ip)
            .then((d) => {
                setIp(d);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.log(e);
            });
    }, [_ip]);
    if (!ip) return <LoadingSpinner bar={true} loading={loading} />;
    return (
        <div className="row">
            <div className="col-lg-6 col-12">
                <div className="card">
                    <div className="card-head">
                        <header>IP Information</header>
                    </div>
                    <div className="card-body mb-5">
                        <LoadingSpinner loading={loading} />
                        <div className="row">
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>IP</span>
                                <h4>
                                    <img src={ip.country_flag} alt={ip.country_name} srcset={ip.country_flag} /> {ip.ip}
                                </h4>
                            </div>
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>Country</span>
                                <h4>{ip.country_name}</h4>
                            </div>
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>Country Capital</span>
                                <h4>{ip.country_capital}</h4>
                            </div>
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>State Provence</span>
                                <h4>{ip.state_prov}</h4>
                            </div>
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>District</span>
                                <h4>{ip.state_prov}</h4>
                            </div>
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>City</span>
                                <h4>{ip.city}</h4>
                            </div>
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>City</span>
                                <h4>{ip.city}</h4>
                            </div>
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>Zip Code</span>
                                <h4>{ip.zipcode}</h4>
                            </div>
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>Internet Service Provider</span>
                                <h4>{ip.isp}</h4>
                            </div>
                            <div className="col-lg-6 col-6 col-md-4">
                                <span>Connection Type</span>
                                <h4>{ip.connection_type}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-6 col-12">
                <div className="card">
                    <div className="card-head">
                        <header>Location on Map</header>
                    </div>
                    <div className="card-body">
                        <Gmaps width={"480px"} height={"420px"} lat={ip.latitude} lng={ip.longitude} zoom={12} loadingMessage={"Map loading please wait.."} params={params}>
                            <Marker lat={ip.latitude} lng={ip.longitude} draggable={true} />
                            <InfoWindow lat={ip.latitude} lng={ip.longitude} content={"Staff Location at the time of login"} />
                            <Circle lat={ip.latitude} lng={ip.longitude} radius={500} />
                        </Gmaps>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IPComponent;
